import React, { useEffect } from 'react';
import { Box, TitleText, Button, ButtonMode } from 'edenred-ui';
import { useFormContext, useController } from 'react-hook-form';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FormFields } from '@epi-forms/helpers';
import { ITerminationDate } from '@epi-models/pages/Beneficiaries';
import { maxLength, hasPendingLoad } from '@epi-helpers/formHelpers/validators';
import { useModal } from '@epi-shared/hooks';

import { PersonalDataField } from '../BeneficiaryDetail/components';
import { TerminationDateDialog } from './components/TerminationDateDialog';

export const TerminationDate = ({
  showTerminationButton = true,
  isAddMode
}: ITerminationDate) => {
  const { t } = useTranslation();
  const { gray85, gray70, sizeExtraSmall, fontSize, warningColor } = useTheme();
  const { isModalOpen, openModal, closeModal } = useModal();
  const { control, watch, trigger } = useFormContext();
  const pendingLoadDate = watch(FormFields.PendingLoadDate);
  const {
    field: { value: EoB }
  } = useController({
    name: FormFields.EndOfBenefit,
    control
  });

  useEffect(() => {
    trigger(FormFields.EndOfBenefit);
  }, [EoB]);

  return (
    <Box>
      <TitleText noMargin color={gray85} fontSize={fontSize} fontWeight={600}>
        {t('containers.beneficiaries.detail.end_of_benefit_title')}
      </TitleText>
      {showTerminationButton && (
        <>
          <Box fontSize={sizeExtraSmall} color={gray70} mt={1}>
            {t('containers.beneficiaries.detail.end_of_benefit_info')}
          </Box>
          <Box mt={2}>
            <Button
              onClick={openModal}
              id="button"
              mode={ButtonMode.Secondary}
              style={{
                borderColor: warningColor,
                color: warningColor
              }}
              type="button"
            >
              {t('containers.beneficiaries.detail.end_of_benefit_button')}
            </Button>
          </Box>
        </>
      )}
      {EoB && (
        <Box mt={3}>
          <PersonalDataField
            label={t('containers.beneficiaries.detail.end_of_benefit')}
            name={FormFields.EndOfBenefit}
            validate={[maxLength(20), hasPendingLoad(pendingLoadDate)]}
            disabled
          />
          <Box mt={3}>
            <PersonalDataField
              label={t('containers.beneficiaries.detail.end_of_founds')}
              name={FormFields.EndOfFunds}
              validate={[maxLength(20)]}
              disabled
            />
          </Box>
        </Box>
      )}
      <TerminationDateDialog
        isOpen={isModalOpen}
        handleClose={closeModal}
        isAddMode={isAddMode}
      />
    </Box>
  );
};
